import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const projects = [
  { city: 'Amsterdam', description: 'Technogym loopband installatie in home gym', image: '/project-amsterdam.webp' },
  { city: 'Rotterdam', description: 'Complete cardiolijn geïnstalleerd', image: '/project-rotterdam.webp' },
  { city: 'Utrecht', description: 'Bedrijfsfitness montage & opbouw', image: '/project-utrecht.webp' },
  { city: 'Den Haag', description: 'Power rack & krachtstation montage', image: '/project-denhaag.webp' },
  { city: 'Eindhoven', description: 'Hotel fitnessruimte ingericht', image: '/project-eindhoven.webp' },
  { city: 'Groningen', description: 'Home gym met loopband & krachtstation geïnstalleerd', image: '/project-groningen2.webp' }
];

export const RecentProjects = () => {
  return (
    <section className="py-16 lg:py-24 bg-neutral-950 relative overflow-hidden" data-testid="recent-projects-section">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 text-yellow-400 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Onze projecten
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Onze recente <span className="text-yellow-400">projecten</span>
          </h2>
          <p className="text-lg text-white/60 leading-relaxed">
            Ontdek een selectie van onze professioneel uitgevoerde installaties en verhuizingen door heel Nederland.
          </p>
        </div>

        {/* Project grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="group relative rounded-3xl overflow-hidden bg-neutral-900 border border-neutral-800 hover:border-yellow-400/50 transition-all duration-500 hover:-translate-y-2"
              data-testid={`project-card-${project.city.toLowerCase().replace(' ', '-')}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={project.image}
                  alt={`${project.city} - ${project.description} door NEXON Installatie & Service`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-80" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-2xl font-black text-white mb-1 group-hover:text-yellow-400 transition-colors duration-300">
                  {project.city}
                </h3>
                <p className="text-white/70 text-sm">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <Link to="/offerte">
            <Button size="lg" className="bg-yellow-400 hover:bg-yellow-300 text-black px-10 py-6 rounded-2xl text-lg font-bold shadow-xl shadow-yellow-400/20 hover:scale-[1.02] transition-all duration-300" data-testid="projects-cta-button">
              Start uw eigen project
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
